// import SocketController from "@/services/Socket/socket.controller";
import i18n from "@/i18n";
import { RegisterUser, registerUserSchema } from "@/types";
import { validateWithSchema } from "@/utils/dataValidators.zod";

export async function sendRegisterUser(newUser: RegisterUser): Promise<
  | {
      rStatus: "success";
    }
  | {
      rStatus: "error";
      rData: string;
    }
> {
  const validatedUser = validateWithSchema(
    newUser,
    registerUserSchema,
    "RegisterUser"
  );
  if (!validatedUser) {
    console.error(`Invalid user data`, newUser);
    return {
      rStatus: "error",
      rData: i18n.t("Invalid user data"),
    };
  }

  console.log(`Sending register user command`);
  try {
    // TODO: Uncomment this in a real project
    // Send authentication command
    // const response = await SocketController.prototype.sendCommand(
    //   "register-user",
    //   { user: validatedUser },
    //   true
    // );

    const response = {
      status: 202,
    };

    console.log(response);

    if (response.status === 200 || response.status === 202) {
      return { rStatus: "success" };
    }

    if (response.status === 0) {
      return { rStatus: "error", rData: i18n.t("Network error") };
    }

    return {
      rStatus: "error",
      rData: i18n.t("Registration failed"),
    };
  } catch (error) {
    console.log(error);
    return { rStatus: "error", rData: i18n.t("Registration failed") };
  }
}
